(() => {
    // node_modules/ftdomdelegate/main.js
    function Delegate(root) {
        this.listenerMap = [{}, {}];
        if (root) {
            this.root(root);
        }
        this.handle = Delegate.prototype.handle.bind(this);
        this._removedListeners = [];
    }
    Delegate.prototype.root = function (root) {
        const listenerMap = this.listenerMap;
        let eventType;
        if (this.rootElement) {
            for (eventType in listenerMap[1]) {
                if (listenerMap[1].hasOwnProperty(eventType)) {
                    this.rootElement.removeEventListener(eventType, this.handle, true);
                }
            }
            for (eventType in listenerMap[0]) {
                if (listenerMap[0].hasOwnProperty(eventType)) {
                    this.rootElement.removeEventListener(eventType, this.handle, false);
                }
            }
        }
        if (!root || !root.addEventListener) {
            if (this.rootElement) {
                delete this.rootElement;
            }
            return this;
        }
        this.rootElement = root;
        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.addEventListener(eventType, this.handle, true);
            }
        }
        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.addEventListener(eventType, this.handle, false);
            }
        }
        return this;
    };
    Delegate.prototype.captureForType = function (eventType) {
        return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
    };
    Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
        let root;
        let listenerMap;
        let matcher;
        let matcherParam;
        if (!eventType) {
            throw new TypeError("Invalid event type: " + eventType);
        }
        if (typeof selector === "function") {
            useCapture = handler;
            handler = selector;
            selector = null;
        }
        if (useCapture === void 0) {
            useCapture = this.captureForType(eventType);
        }
        if (typeof handler !== "function") {
            throw new TypeError("Handler must be a type of Function");
        }
        root = this.rootElement;
        listenerMap = this.listenerMap[useCapture ? 1 : 0];
        if (!listenerMap[eventType]) {
            if (root) {
                root.addEventListener(eventType, this.handle, useCapture);
            }
            listenerMap[eventType] = [];
        }
        if (!selector) {
            matcherParam = null;
            matcher = matchesRoot.bind(this);
        } else if (/^[a-z]+$/i.test(selector)) {
            matcherParam = selector;
            matcher = matchesTag;
        } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
            matcherParam = selector.slice(1);
            matcher = matchesId;
        } else {
            matcherParam = selector;
            matcher = Element.prototype.matches;
        }
        listenerMap[eventType].push({
            selector,
            handler,
            matcher,
            matcherParam
        });
        return this;
    };
    Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
        let i;
        let listener;
        let listenerMap;
        let listenerList;
        let singleEventType;
        if (typeof selector === "function") {
            useCapture = handler;
            handler = selector;
            selector = null;
        }
        if (useCapture === void 0) {
            this.off(eventType, selector, handler, true);
            this.off(eventType, selector, handler, false);
            return this;
        }
        listenerMap = this.listenerMap[useCapture ? 1 : 0];
        if (!eventType) {
            for (singleEventType in listenerMap) {
                if (listenerMap.hasOwnProperty(singleEventType)) {
                    this.off(singleEventType, selector, handler);
                }
            }
            return this;
        }
        listenerList = listenerMap[eventType];
        if (!listenerList || !listenerList.length) {
            return this;
        }
        for (i = listenerList.length - 1; i >= 0; i--) {
            listener = listenerList[i];
            if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
                this._removedListeners.push(listener);
                listenerList.splice(i, 1);
            }
        }
        if (!listenerList.length) {
            delete listenerMap[eventType];
            if (this.rootElement) {
                this.rootElement.removeEventListener(eventType, this.handle, useCapture);
            }
        }
        return this;
    };
    Delegate.prototype.handle = function (event) {
        let i;
        let l;
        const type = event.type;
        let root;
        let phase;
        let listener;
        let returned;
        let listenerList = [];
        let target;
        const eventIgnore = "ftLabsDelegateIgnore";
        if (event[eventIgnore] === true) {
            return;
        }
        target = event.target;
        if (target.nodeType === 3) {
            target = target.parentNode;
        }
        if (target.correspondingUseElement) {
            target = target.correspondingUseElement;
        }
        root = this.rootElement;
        phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
        switch (phase) {
            case 1:
                listenerList = this.listenerMap[1][type];
                break;
            case 2:
                if (this.listenerMap[0] && this.listenerMap[0][type]) {
                    listenerList = listenerList.concat(this.listenerMap[0][type]);
                }
                if (this.listenerMap[1] && this.listenerMap[1][type]) {
                    listenerList = listenerList.concat(this.listenerMap[1][type]);
                }
                break;
            case 3:
                listenerList = this.listenerMap[0][type];
                break;
        }
        let toFire = [];
        l = listenerList.length;
        while (target && l) {
            for (i = 0; i < l; i++) {
                listener = listenerList[i];
                if (!listener) {
                    break;
                }
                if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
                    toFire = [];
                } else if (listener.matcher.call(target, listener.matcherParam, target)) {
                    toFire.push([event, target, listener]);
                }
            }
            if (target === root) {
                break;
            }
            l = listenerList.length;
            target = target.parentElement || target.parentNode;
            if (target instanceof HTMLDocument) {
                break;
            }
        }
        let ret;
        for (i = 0; i < toFire.length; i++) {
            if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
                continue;
            }
            returned = this.fire.apply(this, toFire[i]);
            if (returned === false) {
                toFire[i][0][eventIgnore] = true;
                toFire[i][0].preventDefault();
                ret = false;
                break;
            }
        }
        return ret;
    };
    Delegate.prototype.fire = function (event, target, listener) {
        return listener.handler.call(target, event, target);
    };
    const main_delegate = Delegate;
    function matchesTag(tagName, element) {
        return tagName.toLowerCase() === element.tagName.toLowerCase();
    }
    function matchesRoot(selector, element) {
        if (this.rootElement === window) {
            return element === document || element === document.documentElement || element === window;
        }
        return this.rootElement === element;
    }
    function matchesId(id, element) {
        return id === element.id;
    }
    Delegate.prototype.destroy = function () {
        this.off();
        this.root();
    };

    function triggerEvent(element, name, data = {}) {
        element.dispatchEvent(new CustomEvent(name, {
            bubbles: true,
            detail: data
        }));
    }
    function filterShopifyEvent(event, domElement, callback) {
        let executeCallback = false;
        if (event.type.includes("shopify:section")) {
            if (domElement.hasAttribute("section") && domElement.getAttribute("section") === event.detail.sectionId) {
                executeCallback = true;
            }
        } else if (event.type.includes("shopify:block") && event.target === domElement) {
            executeCallback = true;
        }
        if (executeCallback) callback(event);
    }
    // === 焦点陷阱逻辑 ===
    function trapFocus(container) {
        const focusableSelectors = [
            'a[href]', 'button:not([disabled])', 'input:not([disabled])',
            'select:not([disabled])', 'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ];
        const focusableEls = Array.from(container.querySelectorAll(focusableSelectors.join(',')));
        if (focusableEls.length === 0) return;

        const firstEl = focusableEls[0];
        const lastEl = focusableEls[focusableEls.length - 1];

        function handleKey(e) {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstEl) {
                    e.preventDefault();
                    lastEl.focus();
                }
            } else { // Tab
                if (document.activeElement === lastEl) {
                    e.preventDefault();
                    firstEl.focus();
                }
            }
        }

        container.__focusHandler = handleKey;
        document.addEventListener('keydown', handleKey);
        firstEl.focus();
    }

    function releaseFocus(container) {
        if (container.__focusHandler) {
            document.removeEventListener('keydown', container.__focusHandler);
            delete container.__focusHandler;
        }
    }

    function throttle(callback, delay3 = 15) {
        let throttleTimeout = null, storedEvent = null;
        const throttledEventHandler = (event) => {
            storedEvent = event;
            const shouldHandleEvent = !throttleTimeout;
            if (shouldHandleEvent) {
                callback(storedEvent);
                storedEvent = null;
                throttleTimeout = setTimeout(() => {
                    throttleTimeout = null;
                    if (storedEvent) {
                        throttledEventHandler(storedEvent);
                    }
                }, delay3);
            }
        };
        return throttledEventHandler;
    }

    function getSiblings(element, filter, includeSelf = false) {
        let siblings = [];
        let currentElement = element;
        while (currentElement = currentElement.previousElementSibling) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }
        if (includeSelf) {
            siblings.push(element);
        }
        currentElement = element;
        while (currentElement = currentElement.nextElementSibling) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }
        return siblings;
    }
    /* 动画 */
    var MediaFeatures = class {
        static prefersReducedMotion() {
            return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        static supportsHover() {
            return window.matchMedia("(pointer: fine)").matches;
        }
    };


    var CustomHTMLElement = class extends HTMLElement {
        constructor() {
            super();
            this._hasSectionReloaded = false;
            if (Shopify.designMode) {
                this.rootDelegate.on("shopify:section:select", (event) => {
                    const parentSection = this.closest(".shopify-section");
                    if (event.target === parentSection && event.detail.load) {
                        this._hasSectionReloaded = true;
                    }
                });
            }
        }
        get rootDelegate() {
            return this._rootDelegate = this._rootDelegate || new main_delegate(document.documentElement);
        }
        get delegate() {
            return this._delegate = this._delegate || new main_delegate(this);
        }
        untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
            const onBecameVisible = () => {
                this.classList.add("became-visible");
                this.style.opacity = "1";
            };
            return new Promise((resolve) => {
                if (window.IntersectionObserver) {
                    this.intersectionObserver = new IntersectionObserver((event) => {
                        if (event[0].isIntersecting) {
                            this.intersectionObserver.disconnect();
                            requestAnimationFrame(() => {
                                resolve();
                                onBecameVisible();
                            });
                        }
                    }, intersectionObserverOptions);
                    this.intersectionObserver.observe(this);
                } else {
                    resolve();
                    onBecameVisible();
                }
            });
        }
        disconnectedCallback() {
            this.delegate.destroy();
            this.rootDelegate.destroy();
            delete this._delegate;
            delete this._rootDelegate;
        }
    };

    var NativeVideo = class extends HTMLElement {
        constructor() {
            super();
            this.hasLoaded = false;
            if (this.autoPlay) {
                this.play();
            } else {
                this.addEventListener("click", this.play.bind(this), { once: true });
            }
        }
        get autoPlay() {
            return this.hasAttribute("autoplay");
        }
        play() {
            if (!this.hasLoaded) {
                this._replaceContent();
            }
            this.querySelector("video").play();
        }
        pause() {
            if (this.hasLoaded) {
                this.querySelector("video").pause();
            }
        }
        _replaceContent() {
            const node = this.querySelector("template").content.firstElementChild.cloneNode(true);
            this.innerHTML = "";
            this.appendChild(node);
            this.firstElementChild.addEventListener("play", () => {
                this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
            });
            this.firstElementChild.addEventListener("pause", () => {
                this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
            });
            this.hasLoaded = true;
        }
    };
    window.customElements.define("native-video", NativeVideo);

    var template = `
    <style>
        :host {
        display: inline-block;
        contain: layout;
        position: relative;
        }
        
        :host([hidden]) {
        display: none;
        }
        
        s {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;
        background-image:
            var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
        background-position: top, bottom, left, right;
        background-repeat: no-repeat;
        background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
        }
    </style>
    <slot></slot>
    <s></s>
    `;
    var Updater = class {
        constructor(targetElement) {
            this.scheduleUpdate = throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
            this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
        }
        start(element) {
            if (this.element) {
                this.stop();
            }
            if (element) {
                element.addEventListener("scroll", this.scheduleUpdate);
                this.resizeObserver.observe(element);
                this.element = element;
            }
        }
        stop() {
            if (!this.element) {
                return;
            }
            this.element.removeEventListener("scroll", this.scheduleUpdate);
            this.resizeObserver.unobserve(this.element);
            this.element = null;
        }
        update(targetElement, style) {
            if (!this.element) {
                return;
            }
            const maxSize = style.getPropertyValue("--scroll-shadow-size") ? parseInt(style.getPropertyValue("--scroll-shadow-size")) : 0;
            const scroll = {
                top: Math.max(this.element.scrollTop, 0),
                bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
                left: Math.max(this.element.scrollLeft, 0),
                right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
            };
            requestAnimationFrame(() => {
                for (const position of ["top", "bottom", "left", "right"]) {
                    targetElement.style.setProperty(`--${position}`, `${scroll[position] > maxSize ? maxSize : scroll[position]}px`);
                }
            });
        }
    };
    var ScrollShadow = class extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: "open" }).innerHTML = template;
            this.updater = new Updater(this.shadowRoot.lastElementChild);
        }
        connectedCallback() {
            this.shadowRoot.querySelector("slot").addEventListener("slotchange", () => this.start());
            this.start();
        }
        disconnectedCallback() {
            this.updater.stop();
        }
        start() {
            this.updater.start(this.firstElementChild);
        }
    };
    if ("ResizeObserver" in window) {
        window.customElements.define("scroll-shadow", ScrollShadow);
    }

    class ProductMediaImages extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.initSwiper();
            this.addEventListener("swiperControl:select", (event) => this.select(event.detail.index));
        }

        select(idx) {
            this.swiper.slideToLoop(idx);
        }
        initSwiper() {
            const swiperEl = this.querySelector('.mediaSwiper');
            const _this = this;
            if (!swiperEl) return;
            const lastIdx = this.dataset.lastIdx;
            this.swiper = new Swiper(swiperEl, {
                observer: true,
                observeParents: true,
                fadeEffect: {
                    crossFade: true
                },
                touchStartPreventDefault: true,
                passiveListeners: false,
                slidesPerView: 1,
                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                on: {
                    init(swiperInstance) {
                        const realIndex = swiperInstance.realIndex;
                        triggerEvent(_this, "swiper:ready", {
                            realIndex
                        })
                        document.addEventListener("product-info:updating-media", (event) => {
                            const featuredMediaId = event.detail.featuredMediaId;
                            const slides = swiperInstance.slides;
                            slides.forEach(slide => {
                                const mediaId = slide.getAttribute('data-media-id');
                                if (mediaId == featuredMediaId) {
                                    swiperInstance.slideToLoop(slide.index);
                                }
                            });
                        });
                    },
                    slideChange(swiperInstance) {
                        const realIndex = swiperInstance.realIndex;
                        $(this).find('.swiper-slide video').each(function () {
                            this.pause();
                        });
                        triggerEvent(_this, "swiper:slide-changed", {
                            realIndex
                        })
                    }
                },
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev'),
                },
            });
            if (lastIdx) {
                this.swiper.slideToLoop(lastIdx);
            }
        }
    }
    if (!customElements.get('product-media-images')) {
        customElements.define('product-media-images', ProductMediaImages);
    }

    var ProductMediaControls = class extends CustomHTMLElement {
        async connectedCallback() {
            this.productMediaImages.addEventListener("swiper:ready", this._onSlideChanged.bind(this, false));
            this.productMediaImages.addEventListener("swiper:slide-changed", this._onSlideChanged.bind(this, true));
            this.delegate.on("click", '[data-action="select"]', (event, target) => {
                this.productMediaImages.select(target.dataset.idx)
            });
        }
        get productMediaImages() {
            return this._productMediaImages = this._productMediaImages || document.getElementById(this.getAttribute("controls"));
        }
        async _onSlideChanged(animate = true, event) {
            const realIndex = event.detail.realIndex || 0;
            const activeItem = this.querySelector(`.product__thumbnail-item[data-idx="${realIndex}"]`);
            activeItem.setAttribute("aria-current", "true");
            getSiblings(activeItem).forEach((sibling) => sibling.removeAttribute("aria-current"));
            requestAnimationFrame(() => {
                if (activeItem.offsetParent && activeItem.offsetParent !== this) {
                    const windowHalfHeight = activeItem.offsetParent.clientHeight / 2, windowHalfWidth = activeItem.offsetParent.clientWidth / 2;
                    activeItem.offsetParent.scrollTo({
                        behavior: animate ? "smooth" : "auto",
                        top: activeItem.offsetTop - windowHalfHeight + activeItem.clientHeight / 2,
                        left: activeItem.offsetLeft - windowHalfWidth + activeItem.clientWidth / 2
                    });
                }
            });
        }
    };
    window.customElements.define("product-media-controls", ProductMediaControls);


    class VideoIntersectionInsert extends HTMLElement {
        constructor() {
            super();
            this._observer = null;
            this._isPlaying = false;
            this._loaded = false;
            this._playedOnce = false;
            this._onlyLoad = false;
        }

        connectedCallback() {
            const videoHtml = this.dataset.src;
            if (!videoHtml) return;
            this._observer = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0];
                    const visibleHeight = entry.intersectionRect.height;
                    this._onlyLoad = this.hasAttribute("onlyLoad");
                    if (this.hasAttribute("once") && this._playedOnce) return;
                    if (visibleHeight >= 100 && !this._loaded) {
                        const videoDiv = document.createElement("div");
                        videoDiv.innerHTML = videoHtml;
                        this._video = videoDiv.querySelector("video");
                        this.querySelectorAll("img").forEach((b) => (b.style.visibility = "hidden"));
                        this.appendChild(this._video);
                        this._loaded = true;
                        if (this._onlyLoad) return
                        this._video.play().catch(() => { });
                        this._isPlaying = true;
                        this._video.addEventListener("ended", () => {
                            if (this.hasAttribute("once")) {
                                this._playedOnce = true;
                                this._observer?.disconnect();
                                this._video.pause();
                            }
                        });
                    }
                    if (visibleHeight >= 100 && !this._isPlaying && !this._playedOnce && !this._onlyLoad) {
                        this._video.play().catch(() => { });
                        this._isPlaying = true;
                    } else if (visibleHeight < 100 && this._isPlaying && !this.hasAttribute("once")) {
                        this._video.pause();
                        this._isPlaying = false;
                    }
                },
                {
                    root: null,
                    threshold: Array.from({ length: 101 }, (_, i) => i / 100),
                }
            );

            this._observer.observe(this);
        }

        disconnectedCallback() {
            this._observer?.disconnect();
        }
    }

    if (!customElements.get("video-intersection-insert")) {
        customElements.define("video-intersection-insert", VideoIntersectionInsert);
    }
})();
